import React, { useState } from "react";
import {
  CustomButton2,
  CustomIcon,
  CustomInput,
  CustomModal,
} from "../../../../components";
import Context from "../../../../context";
import { ICreateAndUpdateDriver } from "../../../../types/driver.interface";
import "./index.sass";
import { Container, Row } from "react-bootstrap";
import Column from "../../../../components/CustomView/Column";

const Delete = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, removeCategory, selectedCategory, loading } =
    React.useContext(Context.CategoryScreen);

  const submitHandler = () => {
    removeCategory!(selectedCategory?._id as string);
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-update-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "DELETE"}
        minWidth={"22rem"}
      >
        <form>
          <Container>
            <Row>
              <Column>
                <p style={{ fontSize: "0.9rem" }}>
                  آیا از خذف دسته بندی مطمئن هستید؟
                </p>
              </Column>
            </Row>
            <div style={{ marginTop: "1rem" }}>
              <Row>
                <Column>
                  <CustomButton2
                    title={"ثبت"}
                    type="primary"
                    onClick={submitHandler}
                    isLoading={loading}
                  />
                </Column>
              </Row>
            </div>
          </Container>
        </form>
      </CustomModal>
    </section>
  );
};

export default Delete;
